import React from "react";
import { Box, Chip, Typography, useMediaQuery } from "@mui/material";
import LOGO from "../../images/LOGO.svg";
import LOGOTitle from "../../images/LOGO_Title.svg";
import ChipBtn from "../UI/Chip/Chip";
import { useNavigate } from "react-router-dom";

const HomeTop = () => {
  const navigate = useNavigate();
  const smallScreen = useMediaQuery("(min-width:600px)");
  const smallScreen1000 = useMediaQuery("(min-width:1064px)");
  return (
    <Box className="home-top-container">
      <Box className="home-top">
        {smallScreen && (
          <Box className="left-home-top">
            <img
              src={LOGO}
              alt="Rawdat Logo"
              width={smallScreen1000 ? 300 : 200}
              height={250}
            />
            <img
              src={LOGOTitle}
              alt="RAWDAT.AI"
              width={smallScreen1000 ? 300 : 200}
            />
          </Box>
        )}
        <Box className="right-home-top">
          <Typography variant="h3">
            Welcome to Serverless Sky Computing
          </Typography>
          <Typography variant="h5" sx={{ color: "#00C1EF" }}>
            A platform where developers innovate without constraints.
          </Typography>

          {/*  <Typography variant="body1" sx={{ mt: 1.5 }}>
            {` Thank you for choosing Rawdat.AI as your serverless platform of
          choice. Clicking on ‘Getting Started’ will direct you to the ‘Create’
          tab where you can start deploying your functions.`}
          </Typography>

          <Typography variant="body1">
            {`You can navigate to the documentation section for more details on using the platform. We hope you enjoy using Rawdat.AI and we very much value your feedback. Enjoy!`}
          </Typography> */}

          <Chip
            variant="filled"
            color="primary"
            label="Get started"
            sx={{
              /* width: "129px", */
              width: "fit-content",
              cursor: "pointer",
              mt: 2,
            }}
            onClick={() => navigate("/subscribe")}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default HomeTop;
